/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_APPLICATIONS = gql`
  query GetListOfApplication($input: GetAppListInput) {
    getListOfApplication(input: $input) {
      totalCount
      totalPages
      currentPage
      pageSize
      data {
        displayStatus
        createdAt
        appliedOn
        updatedAt
        applicant
        completedOn
        applicantInfo {
          fullName
          firstName
          middleName
          lastName
          email
          createdAt
          accountStatus
          nationality
        }
        applicationNo
        appliedBy
        comment
        status
        type
        employerInfo {
          name
        }
      }
    }
  }
`;
